import { FailApiResponse, SuccessApiResponse } from '../../../contract/base/Response';
import { createEmailAddressVerificationToken } from '../../../services/identity/user/createEmailAddressVerificationToken';
import useFetch from '../../useFetch';

export function useCreateEmailAddressVerificationToken(
  successCallback?: (response: SuccessApiResponse) => void,
  errorCallback?: (response: FailApiResponse) => void,) {
  const { loading, response, fetch } = useFetch({
    fetcher: createEmailAddressVerificationToken
  });

  const ftch = async (request: Parameters<typeof createEmailAddressVerificationToken>[0]) => {
    let resp = await fetch(request);
    if (resp?.success) {
      successCallback && successCallback(resp);
    }
    else if (resp) {
      errorCallback && errorCallback(resp);
    }
  }

  return {
    loading,
    createEmailAddressVerificationToken: ftch
  };
}